/**
 * UserProfile — Personalisierung (Abschnitt 3/4 der Anforderungen).
 *
 * Öffentlicher Lesezugriff auf alles; Login schafft nur Personalisierung:
 * gewählter Bezirk + Einstellungen. Rollen: USER (Personalisierung) und
 * ADMIN (Sync-Status, Mitmachen-Kuration).
 * Konvention: {Entity}, {Entity}Overview, Update{Entity}.
 */
export var AppUserRole;
(function (AppUserRole) {
    AppUserRole["USER"] = "user";
    AppUserRole["ADMIN"] = "admin";
})(AppUserRole || (AppUserRole = {}));
export const USER_PROFILE_OBJECT = "userProfile";
//# sourceMappingURL=user-profile-model.js.map